import { game_binaries_hosts } from "./constants";

export default function (host) {
  return game_binaries_hosts.includes(host);
}
